import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { Web3WalletProvider } from './contexts/Web3WalletProvider.tsx'
import { VoiceProvider } from './contexts/VoiceContext.tsx'
import { TransactionProvider } from './contexts/TransactionContext.tsx'

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration)
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError)
      })
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Web3WalletProvider>
      <VoiceProvider>
        <TransactionProvider>
          <App />
        </TransactionProvider>
      </VoiceProvider>
    </Web3WalletProvider>
  </React.StrictMode>,
)